import {
  ADD_PAGE,
  ORDER_PAGES,
  REMOVE_PAGE,
  UPDATE_PAGE,
  SET_SELECTED_PAGE,
  SET_PAGES,
  BATCH_UPDATE_PAGES,
  FETCH_PAGES
} from '../types'
import { MagazinesResource, PagesResource } from '../../resources/index'

export const addPage = page => ( {
  type: ADD_PAGE,
  payload: page
} )

export const removePage = id => ( {
  type: REMOVE_PAGE,
  payload: id,
  async: PagesResource.delete( id )
} )

export const setPages = pages => ( {
  type: SET_PAGES,
  payload: pages
} )

export const updatePage = page => ( {
  type: UPDATE_PAGE,
  payload: page
} )

export const setActivePage = page => ( {
  type: SET_SELECTED_PAGE,
  payload: page
} )

export const setPagesOrder = orders => ( {
  type: ORDER_PAGES,
  payload: orders
} )

export const batchPagesUpdate = payload => ( {
  type: BATCH_UPDATE_PAGES,
  payload: payload
} )

export const fetchPages = magazineID => ( {
  type: FETCH_PAGES,
  async: MagazinesResource.getPages( magazineID ),
  callback: setPages
} )

export const savePage = magazine => ( {
  async: PagesResource.save( magazine ),
  callback: addPage
} )

export const clonePage = ( id, data ) => ( {
  async: PagesResource.clonePage( id, data ),
  callback: addPage
} )


// WEBPACK FOOTER //
// ./src/store/actions/pages.js